export default function Footer() {
  return (
    <footer id="contato" className="bg-ink text-cream-200">
      <div className="max-w-6xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <img
            src="/logo.png"
            alt="OK!pag"
            className="h-10 w-auto"
            width="160"
            height="79"
          />
          <p className="mt-4 text-cream-300/80 max-w-sm leading-relaxed">
            Pagamentos simples, do jeito certo. Construído pra quem
            tem coisa melhor pra fazer do que brigar com gateway.
          </p>
        </div>

        <div>
          <div className="font-display font-bold text-cream-50 mb-4 tracking-tight">
            Contato
          </div>
          <ul className="space-y-2 text-sm">
            <li>
              <a
                href="mailto:contato@okpag.com.br"
                className="hover:text-brand-400 transition-colors"
              >
                contato@okpag.com.br
              </a>
            </li>
            <li className="text-cream-300/70">Brasil</li>
          </ul>
        </div>

        <div>
          <div className="font-display font-bold text-cream-50 mb-4 tracking-tight">
            Legal
          </div>
          <ul className="space-y-2 text-sm">
            <li>
              <a
                href="/termos-de-uso.html"
                className="hover:text-brand-400 transition-colors"
              >
                Termos de uso
              </a>
            </li>
            <li>
              <a
                href="/politica-de-privacidade.html"
                className="hover:text-brand-400 transition-colors"
              >
                Política de privacidade
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-cream-300/10">
        <div className="max-w-6xl mx-auto px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-cream-300/60">
          <div>© {new Date().getFullYear()} OK!pag. Todos os direitos reservados.</div>
          <div className="flex items-center gap-1.5">
            <span className="h-1.5 w-1.5 rounded-full bg-brand-500" />
            <span>operacional</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
